import { render, staticRenderFns } from "./cgoods.vue?vue&type=template&id=0ba018ee&scoped=true&"
import script from "./cgoods.vue?vue&type=script&lang=js&"
export * from "./cgoods.vue?vue&type=script&lang=js&"
import style0 from "./cgoods.vue?vue&type=style&index=0&id=0ba018ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba018ee",
  null
  
)

export default component.exports